import * as api from '@tytapp/api';
import { Model } from '../common';

@Model('Production')
export class Production extends api.ApiAbbreviatedProduction {

    static API = api.ProductionsApi;

    static async podcasts(offset = 0, limit = 10): Promise<Production[]> {
        return await <any>Production.inject(api.ProductionsApi)
            .getLatestPodcasts(offset, limit)
            .toPromise()
            .catch(response => { throw response.json(); })
    }

    static async vods(offset = 0, limit = 10): Promise<Production[]> {
        return await <any>Production.inject(api.ProductionsApi)
            .getLatestVODs(offset, limit)
            .toPromise()
            .catch(response => { throw response.json(); })
    }
}